import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fe-pick-up-options',
    templateUrl: './pick-up-options.component.html',
    styleUrls: ['./pick-up-options.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class PickUpOptionsComponent {}
